exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-tie-break-no-tsx": () => import("./../../../src/pages/tie-break/no.tsx" /* webpackChunkName: "component---src-pages-tie-break-no-tsx" */),
  "component---src-pages-tie-break-yes-tsx": () => import("./../../../src/pages/tie-break/yes.tsx" /* webpackChunkName: "component---src-pages-tie-break-yes-tsx" */)
}

